import Model from 'src/app/core/models/model';

export default class SoilTypeModel extends Model {
  name: string;
  abbreviation?: string;
  description?: string;

  constructor() {
    super();
  }
}

